module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Evistamp","short_name":"starter","start_url":"/","background_color":"#663399","display":"minimal-ui","icon":"src/images/evistamplogoNew.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"f77e9f193ee80d8ac22e482b6cf43d17"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
